import { render, staticRenderFns } from "./common-personal.vue?vue&type=template&id=4a519ddd&scoped=true&"
import script from "./common-personal.vue?vue&type=script&lang=ts&"
export * from "./common-personal.vue?vue&type=script&lang=ts&"
import style0 from "./common-personal.vue?vue&type=style&index=0&id=4a519ddd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a519ddd",
  null
  
)

export default component.exports